import { Box, Flex, Image, Text } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import FullLogoWhite from '../images/FullLogoWhite.svg';
import { CallButton } from './Contact';

// Create motion components from Chakra UI components
const MotionFlex = motion(Flex);
const MotionBox = motion(Box);

/**
 * Logo on the left, call-to-action on the right (stacked on mobile)
 */
export default function Hero() {
	return (
		<Flex
			width={{ base: "90%", lg: "80%" }}
			maxWidth={"1200px"}
			margin={"auto"}
			paddingY={{ base: 8, md: 16 }}
			flexDirection={{ base: "column", md: "row" }}
			alignItems={"center"}
			gap={{ base: 10, md: 16 }}
		>
			{/* Logo */}
			<MotionBox
				flex={1}
				display={"flex"}
				justifyContent={"center"}
				initial={{ opacity: 0, scale: 0.9 }}
				animate={{ opacity: 1, scale: 1 }}
				transition={{ duration: 0.7, ease: "easeOut" }}
			>
				<Image
					src={FullLogoWhite}
					alt="Outlaw Defense"
					width={{ base: "85%", md: "80%" }}
					maxWidth={"340px"}
					height="auto"
				/>
			</MotionBox>

			{/* Call to Action */}
			<MotionFlex
				flex={1}
				flexDirection={"column"}
				alignItems={{ base: "center", md: "flex-start" }}
				textAlign={{ base: "center", md: "left" }}
				gap={6}
				initial={{ opacity: 0, x: 50 }}
				animate={{ opacity: 1, x: 0 }}
				transition={{ duration: 0.7, delay: 0.2, ease: "easeOut" }}
			>
				<Flex flexDirection={"column"} gap={2}>
					<Text
						fontFamily={"Martel"}
						fontWeight={"800"}
						fontSize={{ base: "3xl", md: "4xl", lg: "5xl" }}
						lineHeight={1.2}
						color={"white.500"}
					>
						Ready to defend you.
					</Text>
					<Text
						fontFamily={"Montserrat"}
						fontWeight={"500"}
						fontSize={{ base: "lg", md: "xl" }}
						color={"white.500"}
					>
						Joe Wells, board-certified criminal defense attorney in Houston. Call our office today for a confidential consultation.
					</Text>
				</Flex>

				<CallButton />
			</MotionFlex>
		</Flex>
	);
};
